import { toast } from "sonner";
import { TOAST_DURATION } from "@/shared/utils/toast";

export function showLegacyRouteStub(route: string, target: string) {
	toast.warning(`Needs to be wired to ${target}`, {
		description: `${route} has been removed.`,
		duration: TOAST_DURATION.error,
	});
}

export function legacyRouteStubError(route: string, target: string): Error {
	return new Error(`Needs to be wired to ${target}. ${route} has been removed.`);
}
